import { render, staticRenderFns } from "./SendImageEssay.vue?vue&type=template&id=b899f730&scoped=true&"
import script from "./SendImageEssay.vue?vue&type=script&lang=js&"
export * from "./SendImageEssay.vue?vue&type=script&lang=js&"
import style0 from "./SendImageEssay.vue?vue&type=style&index=0&id=b899f730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899f730",
  null
  
)

export default component.exports